// extracted by mini-css-extract-plugin
module.exports = {"main":"AssuredHelpDesk_main__iNOML","responsive":"AssuredHelpDesk_responsive__Q_JDu"};